import { Breakpoint, EventTile, KnfStatus, ZIndex } from '@elearning-platform/ui';
import { css, RuleSet, styled } from 'styled-components';

import { ViewImage } from '../../../../enums';

import { mobileBottomBarHeight, mobileTopBarHeight, sidebarWidth, topBarHeight } from './header.consts';
import { ContentContainerProps } from './header.types';

export const Wrapper = styled.div`
  position: relative;
  height: calc(100vh - ${mobileTopBarHeight} - ${mobileBottomBarHeight});
  min-height: 580px;

  @media ${Breakpoint.SmallDesktop} {
    min-height: 570px;
    height: calc(100vh - ${topBarHeight});
  }
`;

export const HeaderBg = styled.div`
  width: 100%;
  height: calc(100vh - ${mobileBottomBarHeight});
  position: absolute;
  top: -${mobileTopBarHeight};
  left: 0;
  background-image: url(${ViewImage.DashboardV2BgImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: ${ZIndex.Hidden};
  min-height: 650px;

  @media ${Breakpoint.SmallDesktop} {
    width: calc(100% + ${sidebarWidth});
    height: 100vh;
    top: -${topBarHeight};
    left: -${sidebarWidth};
  }
`;

export const ContentContainer = styled.div<ContentContainerProps>`
  height: calc(100vh - ${mobileTopBarHeight} - ${mobileBottomBarHeight});
  padding: 32px 16px 40px 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-shrink: 0;

  @media ${Breakpoint.SmallDesktop} {
    padding: 40px;
    height: calc(100vh - ${topBarHeight});
    ${({ $withRightPadding }: ContentContainerProps): RuleSet<ContentContainerProps> | false => $withRightPadding && css`
      padding-right: 0px;
    `}
  }
`;

export const HeaderWrapper = styled.div``;

export const BottomContainer = styled.div`
  width: 100%;
  height: 400px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export const RightBottomContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 64px;
`;

export const StatisticsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  @media ${Breakpoint.SmallDesktop} {
    flex-direction: row;
  }
`;

export const SectionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media ${Breakpoint.SmallDesktop} {
    padding: 0;
  }
`;

export const MobileEventTile = styled(EventTile)`
  max-width: none;
  width: 100%;
`;

export const MobileEventTileContainer = styled.div`
  padding: 16px;
`;

export const DesktopEventCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const MobileEventCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
`;

export const DesktopKnfStatus = styled(KnfStatus)`
  width: 285px;
`;
